"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHistoricalSeerRating = void 0;
const react_1 = require("react");
const queries_1 = require("../graphql/queries");
const amplifyBootstrap_1 = require("../utils/amplifyBootstrap");
function useHistoricalSeerRating() {
    const [lastGoodSeerRating, setLastGoodSeerRating] = (0, react_1.useState)(null);
    const [historicalSeerRatings, setHistoricalSeerRatings] = (0, react_1.useState)([]);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    const fetchLastGoodSeerRating = (0, react_1.useCallback)(async (hubId) => {
        setLoading(true);
        setError(null);
        try {
            console.log(`Fetching last good SEER rating for hub: ${hubId}`);
            const response = await amplifyBootstrap_1.API.graphql({
                query: queries_1.getLastGoodSeerRating,
                variables: { hubId },
            });
            const lastGoodRating = response.data?.getLastGoodSeerRating;
            if (lastGoodRating) {
                console.log(`Found last good SEER rating: ${lastGoodRating.seerValue} from ${lastGoodRating.calculatedAt}`);
                setLastGoodSeerRating(lastGoodRating);
                return lastGoodRating;
            }
            else {
                console.log(`No historical SEER rating found for hub ${hubId}`);
                setLastGoodSeerRating(null);
                return null;
            }
        }
        catch (err) {
            console.error('Error fetching last good SEER rating:', err);
            const errorMessage = err instanceof Error ? err.message : 'Failed to fetch historical SEER rating';
            setError(errorMessage);
            setLastGoodSeerRating(null);
            return null;
        }
        finally {
            setLoading(false);
        }
    }, []);
    const fetchHistoricalSeerRatings = (0, react_1.useCallback)(async (hubId, startTimestamp, endTimestamp, limit) => {
        setLoading(true);
        setError(null);
        try {
            console.log(`Fetching historical SEER ratings for hub: ${hubId}`, {
                startTimestamp,
                endTimestamp,
                limit,
            });
            const response = await amplifyBootstrap_1.API.graphql({
                query: queries_1.getHistoricalSeerRatings,
                variables: { hubId, startTimestamp, endTimestamp, limit },
            });
            const historicalRatings = response.data?.getHistoricalSeerRatings || [];
            console.log(`Found ${historicalRatings.length} historical SEER ratings for hub ${hubId}`);
            setHistoricalSeerRatings(historicalRatings);
            return historicalRatings;
        }
        catch (err) {
            console.error('Error fetching historical SEER ratings:', err);
            const errorMessage = err instanceof Error ? err.message : 'Failed to fetch historical SEER ratings';
            setError(errorMessage);
            setHistoricalSeerRatings([]);
            return [];
        }
        finally {
            setLoading(false);
        }
    }, []);
    return {
        lastGoodSeerRating,
        historicalSeerRatings,
        loading,
        error,
        fetchLastGoodSeerRating,
        fetchHistoricalSeerRatings,
    };
}
exports.useHistoricalSeerRating = useHistoricalSeerRating;
exports.default = useHistoricalSeerRating;
